import { CLEAR_EMPLOYEE_BY_STRUCT_ID } from "../../../enums/Request/leader.requests.types";

export const clearEmployeeListAction = () => {
    return {
        type: CLEAR_EMPLOYEE_BY_STRUCT_ID,
    };
};